module.exports = __webpack_public_path__ + "static/media/VR2@2x.e99b6924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/VR/VR2@2x.png
// module id = 729
// module chunks = 0